module.exports = __webpack_public_path__ + "assets/img/ShoppingCheckout@2x.4d0ba222.png";